import { useFloorTransitionStore } from '../../store/floorTransitionSlice';
import {
  DUNGEON_REGISTRY,
  DEFAULT_DUNGEON_ID,
} from '../../data/dungeons.config';
import './FloorTransition.scss';
import { useEffect } from 'react';
import { dungeonService } from '../../services/DungeonService';
import { useGameStore } from '../../store';

// Kept in sync with the keyframe timings in FloorTransition.scss: the cover is
// fully opaque at FADE_MS and the whole animation lasts TOTAL_MS.
const FADE_MS = 400;
const TOTAL_MS = 2800;

export const FloorTransition = () => {
  const active = useFloorTransitionStore((s) => s.active);
  const floor = useFloorTransitionStore((s) => s.floor);
  const mode = useFloorTransitionStore((s) => s.mode);
  const end = useFloorTransitionStore((s) => s.end);
  const { setIsPaused } = useGameStore.getState();

  useEffect(() => {
    dungeonService.allowPlayerInput = false;
    const { mode: m, swap } = useFloorTransitionStore.getState();

    // 'enter': the floor is already generated, cover it opaque right away.
    // 'swap': fade the cover in over the current floor, then run the floor swap
    // once it is fully opaque so the regeneration stays hidden. The sim is
    // frozen for the whole transition by Dungeon's floor-transition tick gate;
    // isPaused here only stops the solo renderer (co-op never freezes on it).
    let swapTimer: ReturnType<typeof setTimeout> | undefined;
    if (m === 'enter') {
      setIsPaused(true);
    } else {
      swapTimer = setTimeout(() => {
        setIsPaused(true);
        swap?.();
      }, FADE_MS);
    }

    const endTimer = setTimeout(() => {
      end();
      dungeonService.allowPlayerInput = true;
      setIsPaused(false);
    }, TOTAL_MS);

    return () => {
      if (swapTimer) {
        clearTimeout(swapTimer);
      }
      clearTimeout(endTimer);
    };
  }, [end, setIsPaused]);

  if (!active || floor === null) {
    return null;
  }

  const currentDungeonId =
    useGameStore.getState().currentDungeonId ?? DEFAULT_DUNGEON_ID;
  const dungeon =
    DUNGEON_REGISTRY[currentDungeonId] ?? DUNGEON_REGISTRY[DEFAULT_DUNGEON_ID];
  const transitionImage =
    dungeonService.resolveFloorInfo(floor).biome.transitionImage;

  return (
    <div className={`floor-transition${mode === 'enter' ? ' is-enter' : ''}`}>
      {transitionImage && (
        <div
          className="floor-transition-bg"
          style={{ backgroundImage: `url(${transitionImage})` }}
        />
      )}
      <div className="floor-transition-content">
        <div className="floor-transition-floor">Étage {floor}</div>
        <div className="floor-transition-dungeon">{dungeon.label}</div>
      </div>
    </div>
  );
};
